import { jsx as _jsx, jsxs as _jsxs } from "@emotion/react/jsx-runtime";
import React from "react";
import iconSizes from "../iconSizes";
import { deprecatedPropValueMessage } from "../../../utils/deprecationUtils";
var isDeprecatedIconSize = function(iconSize) {
    if (typeof iconSize === 'undefined') {
        return false;
    }
    return iconSize === 'xl';
};
var CommunityIcon = function(param) {
    var _size = param.size, size = _size === void 0 ? 's' : _size, _color = param.color, color = _color === void 0 ? 'currentColor' : _color, title = param.title;
    if (isDeprecatedIconSize(size)) {
        deprecatedPropValueMessage({
            componentName: 'Icon',
            propName: 'size',
            propValue: 'xl',
            date: 'Q3 2022'
        });
    }
    var ref;
    return _jsxs("svg", {
        focusable: "false",
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: '0 0 32 32',
        css: {
            width: iconSizes[size],
            height: iconSizes[size],
            fill: color
        },
        role: "img",
        "aria-hidden": (ref = !title) !== null && ref !== void 0 ? ref : false,
        children: [
            title && _jsx("title", {
                children: title
            }),
            _jsx("g", {
                children: _jsx("svg", {
                    viewBox: "0 0 25 25",
                    children: _jsx("path", {
                        d: "M6.62 3.837a.79.79 0 10-.004 1.58.79.79 0 00.004-1.58zm-2.792.784a2.79 2.79 0 115.58.013 2.79 2.79 0 01-5.58-.013zM2.544 9.566a3.554 3.554 0 013.177-1.95l1.79.003a3.55 3.55 0 013.17 1.97l.002.005.398.811a1 1 0 11-1.796.882l-.396-.809a1.55 1.55 0 00-1.383-.859l-1.79-.004a1.554 1.554 0 00-1.388.854l-.4.805a1 1 0 01-1.79-.89l.406-.818zM17.77 3.864a.79.79 0 10-.004 1.58.79.79 0 00.004-1.58zm-2.792.783a2.79 2.79 0 115.58.014 2.79 2.79 0 01-5.58-.014zM13.694 9.593a3.554 3.554 0 013.177-1.951l1.79.004a3.55 3.55 0 013.17 1.97l.002.005.398.81a1 1 0 11-1.796.882l-.396-.808a1.55 1.55 0 00-1.383-.859l-1.79-.004a1.554 1.554 0 00-1.388.854l-.4.804a1 1 0 11-1.79-.89l.406-.817zM6.591 15.837a.79.79 0 10-.003 1.58.79.79 0 00.003-1.58zm-2.791.784a2.79 2.79 0 115.58.013 2.79 2.79 0 01-5.58-.013zM2.515 21.566a3.554 3.554 0 013.177-1.95l1.79.003a3.55 3.55 0 013.17 1.97l.002.005.398.811a1 1 0 11-1.795.881l-.397-.808a1.55 1.55 0 00-1.382-.859l-1.79-.004a1.554 1.554 0 00-1.388.855l-.4.804a1 1 0 01-1.79-.89l.405-.818zM17.741 15.864a.79.79 0 10-.003 1.58.79.79 0 00.003-1.58zm-2.792.783a2.79 2.79 0 115.58.013 2.79 2.79 0 01-5.58-.013zM13.665 21.593a3.554 3.554 0 013.177-1.951l1.79.004a3.55 3.55 0 013.17 1.97l.002.005.398.81a1 1 0 11-1.795.882l-.397-.808a1.55 1.55 0 00-1.382-.859l-1.79-.004a1.554 1.554 0 00-1.388.854l-.4.804a1 1 0 11-1.79-.89l.405-.817z",
                        fillRule: "evenodd",
                        clipRule: "evenodd"
                    })
                })
            })
        ]
    });
};
CommunityIcon.isCarinaIcon = true;
export default CommunityIcon;
